module.exports = __webpack_public_path__ + "media/components/assets/img/bg/footer-bottom-left-730fc61390a7f0cd041e88091e271353.svg";